<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg ">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div v-for="(notification, index) in notifications" :key="index" class="alert position-fixed top-0 end-0 m-3"
          :class="notification.class" role="alert" style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" type="button" class="btn-close" @click="closeNotification(index)"
            aria-label="Close"></button>
        </div>
        
        <!-- Modal de confirmación para descargar ZIP -->
        <div v-if="mostrarModalConfirmarZip" class="modal fade show" tabindex="-1"
          style="display: block; background: rgba(0,0,0,0.5); z-index: 1050;">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Confirmar descarga de documentos</h5>
                <button type="button" class="btn-close" @click="mostrarModalConfirmarZip = false"></button>
              </div>
              <div class="modal-body">
                <p>¿Estás seguro de que deseas descargar todos los documentos que cumplen con los filtros aplicados?</p>
                <p class="text-warning mb-0">
                  <i class="fas fa-exclamation-triangle me-2"></i>
                  <strong>Nota:</strong> Si hay muchos registros, la generación y descarga del archivo ZIP puede tardar varios minutos. Por favor, no cierres esta ventana durante el proceso.
                </p>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="mostrarModalConfirmarZip = false">Cancelar</button>
                <button class="btn btn-success" @click="confirmarDescargarZip">
                  <span v-if="descargandoZip" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Descargar ZIP
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Loader global para descarga ZIP -->
        <div v-if="descargandoZip" class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style="background: rgba(0,0,0,0.5); z-index: 9998;">
          <div class="bg-white rounded p-4 text-center shadow-lg">
            <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
              <span class="visually-hidden">Generando ZIP...</span>
            </div>
            <h5 class="mb-2">Generando archivo ZIP</h5>
            <p class="text-muted mb-0">Por favor, espere. Esto puede tardar varios minutos si hay muchos documentos.</p>
          </div>
        </div>

        <!-- Modal de Nuevo Registro -->
        <NuevoRegistroModal ref="modalNuevoRegistroRef" :esquema="esquema" :listas-disponibles="listasDisponibles"
          :show-notification="showNotification" @crear-registro="crearRegistro"
          @cerrar-modal="cerrarModalNuevoRegistro" />


        <div class="row">
          <div class="col-lg-8">
              <div class="card mb-4">
               <div class="card-header pb-0 d-flex align-items-center justify-content-between mb-2">
                 <h3 class="mb-0">
                  {{ esquema.nombre }}
                  <span v-if="estadoFiltro === 'pendientes'" class="text-warning fs-6"> - Pendientes de aprobación</span>
                  <span v-else-if="estadoFiltro === 'rechazados'" class="text-danger fs-6"> - Documentos Rechazados</span>
                </h3>
                 <div class="d-flex align-items-center gap-2" v-if="esquema.propiedades">
                  <button class="btn btn-sm btn-outline-secondary mb-0" @click="limpiarFiltros" title="Limpiar Filtros">
                    <i class="fas fa-filter-circle-xmark"></i>
                  </button>
                  <!-- Desplegable de acciones -->
                  <div class="dropdown d-inline-block">
                    <button class="btn btn-sm btn-success mb-0 dropdown-toggle" type="button" data-bs-toggle="dropdown" title="Más acciones">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <router-link :to="`/esquema/${id}/informes`" class="dropdown-item">
                          <i class="fas fa-chart-bar me-2 text-info"></i>Informes
                        </router-link>
                      </li>
                      <li><hr class="dropdown-divider"></li>
                      <li>
                        <a class="dropdown-item" href="#" @click.prevent="exportarAExcel" :class="{ disabled: exportando }">
                          <i class="fas fa-file-excel me-2 text-success"></i>Exportar a Excel
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#" @click.prevent="descargarZipFiltrado" :class="{ disabled: descargandoZip }">
                          <i class="fas fa-file-archive me-2 text-success"></i>Descargar ZIP
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#" @click.prevent="descargarSeleccionados" :class="{ disabled: selectedRows.length === 0 || descargando }">
                          <i class="fas fa-download me-2 text-success"></i>Descargar seleccionados
                        </a>
                      </li>
                      <li v-if="esquema.aprobable"><hr class="dropdown-divider"></li>
                      <li v-if="esquema.aprobable">
                        <a class="dropdown-item" href="#" @click.prevent="verPendientes" :class="{ active: estadoFiltro === 'pendientes' }">
                          <i class="fas fa-clock me-2 text-warning"></i>Ver pendientes
                        </a>
                      </li>
                      <li v-if="esquema.aprobable">
                        <a class="dropdown-item" href="#" @click.prevent="verRechazados" :class="{ active: estadoFiltro === 'rechazados' }">
                          <i class="fas fa-times-circle me-2 text-danger"></i>Ver rechazados
                        </a>
                      </li>
                      <li v-if="esquema.aprobable && estadoFiltro"><hr class="dropdown-divider"></li>
                      <li v-if="esquema.aprobable && estadoFiltro">
                        <a class="dropdown-item" href="#" @click.prevent="verTodos">
                          <i class="fas fa-list me-2"></i>Ver aprobados
                        </a>
                      </li>
                    </ul>
                  </div>
                  <button v-if="esquema.adjuntable" class="btn btn-primary btn-sm mb-0" data-bs-toggle="modal"
                    data-bs-target="#modalNuevoRegistro" title="Nuevo">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div v-if="cargando" class="text-center my-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                  </div>
                </div>
                <div v-if="!cargando">
                  <div class="table-responsive">
                    <table id="dynamicTable" class="table table-striped table-bordered table-sm"
                      style="font-size: 0.85rem;">
                      <thead>
                        <tr v-if="esquema.propiedades && searchFilters.value">
                          <!-- Checkbox para seleccionar todos -->
                          <th style="width: 50px !important; max-width: 50px !important; text-align: center; padding: 0.2rem 0.4rem;">
                            <input type="checkbox" :checked="selectAll" @change="toggleSelectAll"
                              class="form-check-input"
                              style="width: 18px; height: 18px; cursor: pointer; border: 2px solid #dee2e6; border-radius: 3px;">
                          </th>
                          <!-- Generar los encabezados dinámicamente desde el esquema -->
                          <th v-for="(columna, index) in esquema.propiedades" :key="'DynamicTable' + index"
                            style="min-width: 140px !important; max-width: 300px !important; width: auto !important; font-size: 0.8rem; padding: 0.2rem 0.4rem; vertical-align: top; overflow: hidden;">
                            <div class="d-flex align-items-center justify-content-between">
                              <span class="sortable-header" @click="cambiarOrdenamiento(columna.campoBD)"
                                :class="{ 'text-primary': sortColumn === columna.campoBD }"
                                style="cursor: pointer; user-select: none;font-weight: 600;">
                                {{ formatearNombrePropiedad(columna.nombre) }}
                                <i :class="'fas ' + getSortIcon(columna.campoBD)" class="ms-1"></i>
                              </span>
                            </div>
                            <!-- Filtro avanzado con operadores -->
                            <div class="filter-container">
                              <!-- Input de valor según el tipo y operador -->
                              <template
                                v-if="filterOperators[columna.campoBD]?.operator === '□' || filterOperators[columna.campoBD]?.operator === '▦'">
                                <!-- Para vacío/no vacío no necesitamos input -->
                                <div class="filter-empty">
                                  {{ filterOperators[columna.campoBD]?.operator === '□' ? 'Vacio' : 'No vacio' }}
                                </div>
                              </template>
                              <template v-else-if="filterOperators[columna.campoBD]?.operator === '<>'">
                                <!-- Para "Entre" un solo input con separador ";" -->
                                <div class="filter-input-group">
                                  <input type="text" class="filter-value-with-selector"
                                    v-model="filterValues[columna.campoBD]"
                                    :placeholder="columna.tipo === 'date' ? 'ddmmyy;ddmmyy' : 'mín;máx'"
                                    @keyup.enter="fetchData">
                                  <div class="filter-operator-wrapper" :data-field="columna.campoBD">
                                    <div class="filter-operator-dropdown"
                                      :class="{ 'show': showOperatorDropdown[columna.campoBD] }"
                                      @click="toggleOperatorDropdown(columna.campoBD)">
                                      <span class="filter-operator-display">
                                        {{ getOperatorDisplay(filterOperators[columna.campoBD]) }}
                                      </span>
                                      <i class="fas fa-chevron-down filter-operator-arrow"></i>
                                    </div>
                                    <div class="filter-operator-menu" v-show="showOperatorDropdown[columna.campoBD]"
                                      @click.stop>
                                      <div class="filter-operator-option"
                                        v-for="op in getAvailableOperators(columna.tipo)" :key="op.id"
                                        :class="{ 'active': filterOperators[columna.campoBD]?.id === op.id }"
                                        @click="selectOperator(columna.campoBD, op)">
                                        <span class="operator-label">{{ op.label }}</span>
                                        <span class="operator-symbol">{{ op.operator }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template v-else-if="filterOperators[columna.campoBD]?.operator === '≡'">
                                <!-- Para "Listado" un solo input con separador ";" -->
                                <div class="filter-input-group">
                                  <input type="text" class="filter-value-with-selector"
                                    v-model="filterValues[columna.campoBD]" placeholder="valor1;valor2;valor3"
                                    @keyup.enter="fetchData">
                                  <div class="filter-operator-wrapper" :data-field="columna.campoBD">
                                    <div class="filter-operator-dropdown"
                                      :class="{ 'show': showOperatorDropdown[columna.campoBD] }"
                                      @click="toggleOperatorDropdown(columna.campoBD)">
                                      <span class="filter-operator-display">
                                        {{ getOperatorDisplay(filterOperators[columna.campoBD]) }}
                                      </span>
                                      <i class="fas fa-chevron-down filter-operator-arrow"></i>
                                    </div>
                                    <div class="filter-operator-menu" v-show="showOperatorDropdown[columna.campoBD]"
                                      @click.stop>
                                      <div class="filter-operator-option"
                                        v-for="op in getAvailableOperators(columna.tipo)" :key="op.id"
                                        :class="{ 'active': filterOperators[columna.campoBD]?.id === op.id }"
                                        @click="selectOperator(columna.campoBD, op)">
                                        <span class="operator-label">{{ op.label }}</span>
                                        <span class="operator-symbol">{{ op.operator }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template v-else>
                                <!-- Input principal con selector de operador a la derecha -->
                                <div class="filter-input-group">
                                  <template v-if="columna.tipo === 'date'">
                                    <input type="text" class="filter-value-with-selector"
                                      v-model="filterValues[columna.campoBD]" placeholder="ddmmyy"
                                      @keyup.enter="fetchData">
                                  </template>
                                  <template v-else>
                                    <input type="text" class="filter-value-with-selector"
                                      v-model="filterValues[columna.campoBD]" @keyup.enter="fetchData">
                                  </template>

                                  <!-- Selector de operador a la derecha -->
                                  <div class="filter-operator-wrapper" :data-field="columna.campoBD">
                                    <div class="filter-operator-dropdown"
                                      :class="{ 'show': showOperatorDropdown[columna.campoBD] }"
                                      @click="toggleOperatorDropdown(columna.campoBD)">
                                      <span class="filter-operator-display">
                                        {{ getOperatorDisplay(filterOperators[columna.campoBD]) }}
                                      </span>
                                      <i class="fas fa-chevron-down filter-operator-arrow"></i>
                                    </div>
                                    <div class="filter-operator-menu" v-show="showOperatorDropdown[columna.campoBD]"
                                      @click.stop>
                                      <div class="filter-operator-option"
                                        v-for="op in getAvailableOperators(columna.tipo)" :key="op.id"
                                        :class="{ 'active': filterOperators[columna.campoBD]?.id === op.id }"
                                        @click="selectOperator(columna.campoBD, op)">
                                        <span class="operator-label">{{ op.label }}</span>
                                        <span class="operator-symbol">{{ op.operator }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Filtrar y mostrar las filas de datos -->
                        <tr v-for="(item, indexfilteredData) in filteredData" :key="indexfilteredData"
                          @click="seleccionarRegistro(item)"
                          :class="{ 'row-selected': registroSeleccionado.value?.id === item.id, 'row-caducado': esquema.tiene_caducidad && item.caducado == 1 }">
                          <!-- Checkbox para seleccionar la fila -->
                          <td style="width: 50px !important; min-width: 50px !important; max-width: 50px !important; text-align: center; padding: 0.2rem 0.4rem; vertical-align: top;"
                            @click.stop>
                            <input type="checkbox" :checked="isRowSelected(item.id)"
                              @change="toggleRowSelection(item.id)" class="form-check-input"
                              style="width: 18px; height: 18px; cursor: pointer; border: 2px solid #dee2e6; border-radius: 3px;">
                          </td>
                          <td v-for="(columna, indexProp) in esquema.propiedades" :key="'test_' + indexProp"
                            class="table-cell-truncated" :title="getCellValue(item, columna)"
                            style="padding: 0.2rem 0.4rem; font-size: 0.8rem; line-height: 1.2; vertical-align: middle; font-weight: 600;">

                            <template v-if="columna.tipo === 'text'">
                              {{ item[columna.campoBD] }}
                            </template>
                            <template v-else-if="columna.tipo === 'longtext'">
                              {{ item[columna.campoBD] }}
                            </template>
                            <template v-else-if="columna.tipo === 'int'">
                              {{ item[columna.campoBD] != null ? parseInt(item[columna.campoBD]) : '' }}
                            </template>
                            <template v-else-if="columna.tipo === 'decimal'">
                              {{ item[columna.campoBD] != null ? parseFloat(item[columna.campoBD]) : '' }}
                            </template>
                            <template v-else-if="columna.tipo === 'decimal2'">
                              {{ item[columna.campoBD] != null ? formatDecimal(item[columna.campoBD], 2) : '' }}
                            </template>
                            <template v-else-if="columna.tipo === 'decimal4'">
                              {{ item[columna.campoBD] != null ? formatDecimal(item[columna.campoBD], 4) : '' }}
                            </template>
                            <template v-else-if="columna.tipo === 'date'">
                              {{ item[columna.campoBD] != null ? formatDate(item[columna.campoBD]) : '' }}
                            </template>
                            <template v-else-if="columna.tipo === 'list'">
                              {{ item[columna.campoBD] }}
                            </template>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                  <!-- Información de registros y paginación -->
                  <div v-if="totalRecords > 0"
                    class="table-footer d-flex justify-content-between align-items-center px-3 py-2">
                    <!-- Información de filas seleccionadas -->
                    <div class="footer-selection-info">
                    </div>

                    <!-- Controles de paginación -->
                    <div class="footer-pagination-controls d-flex align-items-center gap-3">
                      <!-- Rows per page -->
                      <div class="d-flex align-items-center gap-2" style="height: 100%;">
                        <span class="text-muted small"
                          style="line-height: 1.5; display: flex; align-items: center;">Registros por
                          página</span>
                        <select v-model="pageLength" @change="changePageSize"
                          class="form-select form-select-sm footer-select"
                          style="width: auto; min-width: 65px; height: 32px;">
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                        </select>
                      </div>

                      <!-- Page indicator -->
                      <span class="text-muted small"
                        style="line-height: 1.5; display: flex; align-items: center; height: 32px;">Pagina {{
                        currentPage }} de {{ totalPages }}</span>

                      <!-- Navigation buttons -->
                      <div class="d-flex gap-1 align-items-center" style="height: 100%;">
                        <button class="btn btn-sm btn-outline-secondary footer-nav-btn" @click="changePage(1)"
                          :disabled="currentPage === 1" title="Primera página">
                          «
                        </button>
                        <button class="btn btn-sm btn-outline-secondary footer-nav-btn"
                          @click="changePage(currentPage - 1)" :disabled="currentPage === 1" title="Página anterior">
                          &lt;
                        </button>
                        <button class="btn btn-sm btn-outline-secondary footer-nav-btn"
                          @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"
                          title="Página siguiente">
                          &gt;
                        </button>
                        <button class="btn btn-sm btn-outline-secondary footer-nav-btn" @click="changePage(totalPages)"
                          :disabled="currentPage === totalPages" title="Última página">
                          »
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-lg-4">
          <!-- Panel de Detalle del Documento -->
          <DetalleDocumento :esquema="esquema" :registro-seleccionado="registroSeleccionado"
            :listas-disponibles="listasDisponibles" :show-notification="showNotification" :id="id"
            @guardar-registro="guardarRegistro" @eliminar-registro="confirmarEliminar"
            @actualizar-registro="actualizarRegistro" />
          </div>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import NuevoRegistroModal from "../components/NuevoRegistroModal.vue";
import DetalleDocumento from "../components/DetalleDocumento.vue";
import { computed, onMounted, onBeforeUnmount, reactive, ref, watch, nextTick } from "vue";
import { useRouter } from 'vue-router';
import axiosInstance from "@/axios";
import { useRoute } from 'vue-router';
import "datatables.net";
import "datatables.net-bs5";

export default {
  name: "TableView",
  components: { HeaderMenu, NuevoRegistroModal, DetalleDocumento },
  setup() {
    const router = useRouter();
    const route = useRoute(); // Obtiene la información de la ruta actual

    // Accedemos al parámetro de la ruta de forma reactiva
    const id = computed(() => route.params.id);

    if (!id.value) {
      console.error('Error: No se pudo obtener el ID del esquema desde la ruta');
    }
    const esquema = ref({
      propiedades: [], // Inicializar como un array vacío
    });
    const notifications = ref([]);
    const registroSeleccionado = reactive({});

    // Función para cerrar una notificación
    const closeNotification = (index) => {
      notifications.value.splice(index, 1);
    };

    // Estado de los datos de la tabla y los filtros
    const data = ref([]);
    const filteredData = ref([]);
    const searchFilters = reactive({});
    const filterOperators = reactive({});
    const filterValues = reactive({});
    const showOperatorDropdown = reactive({});
    // Paginación
    // Inicializar pageLength según la resolución de la pantalla
    const getInitialPageLength = () => {
      const screenHeight = window.innerHeight;
      return screenHeight >= 850 ? 20 : 10;
    };
    const pageLength = ref(getInitialPageLength());
    const currentPage = ref(1);
    const totalRecords = ref(0);
    const recordsFiltered = ref(0);
    const cargando = ref(false);
    // Selección de registros
    const selectedRows = ref([]);
    const selectAll = ref(false);
    const descargando = ref(false);
    const exportando = ref(false);
    const descargandoZip = ref(false);
    const mostrarModalConfirmarZip = ref(false);
    // Ordenamiento
    const sortColumn = ref('id');
    const sortDirection = ref('desc');
    // Filtro de estado (pendientes/rechazados)
    const estadoFiltro = ref(null);

    // Configuración de operadores de filtro
    const filters_operator = [
      { id: 1, label: 'Igual', operator: '=' },
      { id: 2, label: 'Mayor/igual', operator: '>=' },
      { id: 3, label: 'Menor/igual', operator: '<=' },
      { id: 4, label: 'Mayor', operator: '>' },
      { id: 5, label: 'Menor', operator: '<' },
      { id: 6, label: 'Contiene', operator: '@' },
      { id: 7, label: 'Empieza', operator: '[' },
      { id: 8, label: 'Termina', operator: ']' },
      { id: 9, label: 'Entre', operator: '<>' },
      { id: 10, label: 'Diferente', operator: '!=' },
      { id: 11, label: 'No contiene', operator: '!@' },
      { id: 13, label: 'Vacio', operator: '□' },
      { id: 14, label: 'No vacio', operator: '▦' },
      { id: 15, label: 'Listado', operator: '≡' }
    ];

    const filters_comparador_text = [1, 6, 7, 8, 10, 11, 13, 14, 15];
    const filters_comparador_number = [1, 2, 3, 4, 5, 9, 10, 13, 14, 15];
    const filters_comparador_datepicker = [1, 2, 3, 4, 5, 9, 10, 13, 14, 15];

    // Función para obtener operadores disponibles según el tipo de columna
    const getAvailableOperators = (tipo) => {
      let operatorIds = [];
      switch (tipo) {
        case 'text':
        case 'longtext':
          operatorIds = filters_comparador_text;
          break;
        case 'integer':
        case 'decimal':
        case 'decimal2':
        case 'decimal4':
          operatorIds = filters_comparador_number;
          break;
        case 'date':
          operatorIds = filters_comparador_datepicker;
          break;
        case 'list':
          operatorIds = filters_comparador_text;
          break;
        default:
          operatorIds = filters_comparador_text;
      }
      return filters_operator.filter(op => operatorIds.includes(op.id));
    };

    // Función para obtener el operador por defecto
    const getDefaultOperator = (tipo) => {
      const operators = getAvailableOperators(tipo);

      // Para campos numéricos y de fecha, usar "Igual" por defecto
      if (['integer', 'decimal', 'decimal2', 'decimal4', 'date'].includes(tipo)) {
        const igualOperator = operators.find(op => op.operator === '=');
        return igualOperator || operators[0];
      }

      // Para campos de texto, usar "Contiene" por defecto
      const contieneOperator = operators.find(op => op.operator === '@');
      return contieneOperator || operators[0];
    };

    // Función para inicializar filtros
    const initializeFilters = () => {
      if (esquema.value.propiedades) {
        esquema.value.propiedades.forEach(propiedad => {
          if (!filterOperators[propiedad.campoBD]) {
            filterOperators[propiedad.campoBD] = getDefaultOperator(propiedad.tipo);
          }
          if (!filterValues[propiedad.campoBD]) {
            filterValues[propiedad.campoBD] = '';
          }
        });
      }
    };

    // Función para aplicar filtros desde query params
    const applyQueryParamsFilters = () => {
      if (!esquema.value.propiedades || !route.query) {
        return false;
      }

      let filtersApplied = false;

      // Iterar sobre las propiedades del esquema
      esquema.value.propiedades.forEach(propiedad => {
        const campoBD = propiedad.campoBD;
        const queryValue = route.query[campoBD];

        if (queryValue !== undefined && queryValue !== null && queryValue !== '') {
          // Aplicar el filtro al valor
          filterValues[campoBD] = String(queryValue);
          // También actualizar searchFilters para mantener consistencia
          searchFilters.value[campoBD] = String(queryValue);
          
          // Establecer el operador por defecto si no está configurado
          if (!filterOperators[campoBD]) {
            filterOperators[campoBD] = getDefaultOperator(propiedad.tipo);
          }
          
          filtersApplied = true;
          console.log(`Filtro aplicado desde query param: ${campoBD} = ${queryValue}`);
        }
      });

      if (filtersApplied) {
        console.log('Filtros de query params aplicados correctamente');
        // Limpiar los query params de la URL después de aplicarlos
        const newQuery = { ...route.query };
        esquema.value.propiedades.forEach(propiedad => {
          if (newQuery[propiedad.campoBD] !== undefined) {
            delete newQuery[propiedad.campoBD];
          }
        });
        
        // Actualizar la URL sin los query params de filtros
        router.replace({ 
          path: route.path, 
          query: Object.keys(newQuery).length > 0 ? newQuery : undefined 
        });
      }

      return filtersApplied;
    };

    // Función para limpiar todos los filtros
    const limpiarFiltros = () => {
      if (esquema.value.propiedades) {
        esquema.value.propiedades.forEach(propiedad => {
          filterOperators[propiedad.campoBD] = getDefaultOperator(propiedad.tipo);
          filterValues[propiedad.campoBD] = '';
          // Limpiar también los valores de filtros especiales (ya no se usan)
          filterValues[propiedad.campoBD + '_min'] = '';
          filterValues[propiedad.campoBD + '_max'] = '';
          searchFilters.value[propiedad.campoBD] = '';
        });
      }
      currentPage.value = 1;
      fetchData();
    };

    // Función para obtener el display del operador (solo símbolo para el selector cerrado)
    const getOperatorDisplay = (operator) => {
      if (!operator) return '';
      return operator.operator || '';
    };

    // Función para alternar el dropdown del operador
    const toggleOperatorDropdown = (campoBD) => {
      // Cerrar todos los otros dropdowns
      Object.keys(showOperatorDropdown).forEach(key => {
        if (key !== campoBD) {
          showOperatorDropdown[key] = false;
        }
      });
      // Alternar el dropdown actual
      const isOpening = !showOperatorDropdown[campoBD];
      showOperatorDropdown[campoBD] = isOpening;
      
      // Si se está abriendo, calcular la posición para position: fixed
      if (isOpening) {
        nextTick(() => {
          const wrapper = document.querySelector(`[data-field="${campoBD}"].filter-operator-wrapper`);
          const menu = wrapper?.querySelector('.filter-operator-menu');
          if (wrapper && menu) {
            const rect = wrapper.getBoundingClientRect();
            menu.style.top = `${rect.bottom}px`;
            menu.style.right = `${window.innerWidth - rect.right}px`;
            menu.style.left = 'auto';
          }
        });
      }
    };

    // Función para seleccionar un operador
    const selectOperator = (campoBD, operator) => {
      filterOperators[campoBD] = operator;
      showOperatorDropdown[campoBD] = false;
    };

    // Función para obtener el valor de una celda para el tooltip
    const getCellValue = (item, columna) => {
      let value = item[columna.campoBD];

      switch (columna.tipo) {
        case 'integer':
          return parseInt(value);
        case 'decimal':
          return parseFloat(value);
        case 'decimal2':
          return formatDecimal(value, 2);
        case 'decimal4':
          return formatDecimal(value, 4);
        case 'date':
          return formatDate(value);
        default:
          return value;
      }
    };

    const totalPages = computed(() => {
      // Usar recordsFiltered si hay filtros aplicados, sino usar totalRecords
      const totalRegistros = recordsFiltered.value !== totalRecords.value ? recordsFiltered.value : totalRecords.value;
      return Math.ceil(totalRegistros / pageLength.value);
    });

    // Computed property para calcular el rango de registros mostrados
    const registrosMostrados = computed(() => {
      const inicio = (currentPage.value - 1) * pageLength.value + 1;
      // Usar recordsFiltered si hay filtros aplicados, sino usar totalRecords
      const totalRegistros = recordsFiltered.value !== totalRecords.value ? recordsFiltered.value : totalRecords.value;
      const fin = Math.min(currentPage.value * pageLength.value, totalRegistros);
      return { inicio, fin };
    });

    const paginationRange = computed(() => {
      const range = [];
      const delta = 2; // Número de páginas antes y después de la actual
      const start = Math.max(1, currentPage.value - delta);
      const end = Math.min(totalPages.value, currentPage.value + delta);
      for (let i = start; i <= end; i++) range.push(i);
      return range;
    });


    // Computed property para agrupar propiedades por grupo y ordenarlas
    const propiedadesAgrupadas = computed(() => {
      if (!esquema.value?.propiedades) return [];

      // Agrupar propiedades por grupo
      const grupos = {};
      esquema.value.propiedades.forEach(propiedad => {
        const grupoNombre = propiedad.grupo || 'Sin grupo';
        if (!grupos[grupoNombre]) {
          grupos[grupoNombre] = {
            nombre: grupoNombre,
            propiedades: []
          };
        }
        grupos[grupoNombre].propiedades.push(propiedad);
      });

      // Convertir a array y ordenar grupos por nombre
      const gruposArray = Object.values(grupos).sort((a, b) => {
        if (a.nombre === 'Sin grupo') return 1;
        if (b.nombre === 'Sin grupo') return -1;
        return a.nombre.localeCompare(b.nombre);
      });

      // Ordenar propiedades dentro de cada grupo por la propiedad 'orden'
      gruposArray.forEach(grupo => {
        grupo.propiedades.sort((a, b) => (a.orden || 0) - (b.orden || 0));
      });

      return gruposArray;
    });

    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
        fetchData();
      }
    };

    const changePageSize = () => {
      currentPage.value = 1; // Volver a la primera página
      fetchData();
    };

    // Funciones para selección de registros
    const toggleRowSelection = (rowId) => {
      const index = selectedRows.value.indexOf(rowId);
      if (index > -1) {
        selectedRows.value.splice(index, 1);
      } else {
        selectedRows.value.push(rowId);
      }
      updateSelectAllState();
    };

    const toggleSelectAll = () => {
      if (selectAll.value) {
        // Deseleccionar todos
        selectedRows.value = [];
      } else {
        // Seleccionar todos los registros de la página actual
        selectedRows.value = data.value.map(row => row.id);
      }
      selectAll.value = !selectAll.value;
    };

    const updateSelectAllState = () => {
      selectAll.value = data.value.length > 0 && selectedRows.value.length === data.value.length;
    };

    const clearSelection = () => {
      selectedRows.value = [];
      selectAll.value = false;
    };

    const isRowSelected = (rowId) => {
      return selectedRows.value.includes(rowId);
    };

    const descargarSeleccionados = async () => {
      if (selectedRows.value.length === 0) return;

      descargando.value = true;
      try {
        const response = await axiosInstance.post(`/api/descargarSeleccionados/${id.value}`, {
          registro_ids: selectedRows.value
        }, {
          responseType: 'blob',
          timeout: 3000000 // 50 minutos para descargas grandes
        });

        // Crear un enlace de descarga
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Obtener el nombre del archivo del header Content-Disposition o usar un nombre por defecto
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'registros_seleccionados.zip';
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        showNotification('Descarga iniciada correctamente', 'alert-success');
      } catch (error) {
        console.error('Error al descargar registros:', error);

        // Manejo de errores específicos según el código de respuesta
        let errorMessage = 'Error al descargar los registros seleccionados';

        if (error.response?.status === 400) {
          errorMessage = 'Array de IDs inválido';
        } else if (error.response?.status === 403) {
          errorMessage = 'Sin permisos para descargar estos registros';
        } else if (error.response?.status === 404) {
          errorMessage = 'Esquema o registros no encontrados';
        } else if (error.response?.status === 500) {
          errorMessage = 'Error en la creación del archivo ZIP';
        }

        showNotification(errorMessage, 'alert-danger');
      } finally {
        descargando.value = false;
      }
    };

    // Función para exportar a Excel
    const exportarAExcel = async () => {
      // Validar que el esquema esté cargado
      if (!esquema.value.propiedades || esquema.value.propiedades.length === 0) {
        showNotification('El esquema aún no está cargado', 'alert-warning');
        return;
      }

      exportando.value = true;
      try {
        // Construir el mismo payload que se usa en fetchData pero sin paginación
        const params = {
          columns: esquema.value.propiedades.map(columna => {
            const operator = filterOperators[columna.campoBD]?.operator || '=';
            return {
              search: {
                value: searchFilters.value[columna.campoBD] || '',
                operator: operator,
                filterValue: filterValues[columna.campoBD] || ''
              }
            };
          }),
          // No incluimos start, length ni draw para obtener todos los registros
          // Parámetros de ordenamiento
          sort_column: sortColumn.value,
          sort_direction: sortDirection.value
        };

        const response = await axiosInstance.post(`/api/exportarExcel/${id.value}`, params, {
          responseType: 'blob',
          timeout: 3000000 // 50 minutos para descargas grandes
        });

        // Crear un enlace de descarga
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Obtener el nombre del archivo del header Content-Disposition o usar un nombre por defecto
        const contentDisposition = response.headers['content-disposition'];
        let filename = `registros_${esquema.value.nombre || 'exportacion'}_${new Date().toISOString().split('T')[0]}.xlsx`;
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
          }
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        showNotification('Exportación a Excel iniciada correctamente', 'alert-success');
      } catch (error) {
        console.error('Error al exportar a Excel:', error);

        // Manejo de errores específicos según el código de respuesta
        let errorMessage = 'Error al exportar los registros a Excel';

        if (error.response?.status === 400) {
          errorMessage = 'Parámetros de filtrado inválidos';
        } else if (error.response?.status === 403) {
          errorMessage = 'Sin permisos para exportar estos registros';
        } else if (error.response?.status === 404) {
          errorMessage = 'Esquema no encontrado';
        } else if (error.response?.status === 500) {
          errorMessage = 'Error en la generación del archivo Excel';
        }

        showNotification(errorMessage, 'alert-danger');
      } finally {
        exportando.value = false;
      }
    };

    // Función para mostrar el modal de confirmación antes de descargar ZIP
    const descargarZipFiltrado = () => {
      // Validar que el esquema esté cargado
      if (!esquema.value.propiedades || esquema.value.propiedades.length === 0) {
        showNotification('El esquema aún no está cargado', 'alert-warning');
        return;
      }
      // Mostrar modal de confirmación
      mostrarModalConfirmarZip.value = true;
    };

    // Función para confirmar y ejecutar la descarga ZIP
    const confirmarDescargarZip = async () => {
      // Cerrar el modal de confirmación
      mostrarModalConfirmarZip.value = false;
      
      descargandoZip.value = true;
      try {
        // Construir el mismo payload que se usa en fetchData pero sin paginación
        const params = {
          columns: esquema.value.propiedades.map(columna => {
            const operator = filterOperators[columna.campoBD]?.operator || '=';
            return {
              search: {
                value: searchFilters.value[columna.campoBD] || '',
                operator: operator,
                filterValue: filterValues[columna.campoBD] || ''
              }
            };
          }),
          // No incluimos start, length ni draw para obtener todos los registros
          // Parámetros de ordenamiento
          sort_column: sortColumn.value,
          sort_direction: sortDirection.value
        };

        const response = await axiosInstance.post(`/api/descargarZipEsquema/${id.value}`, params, {
          responseType: 'blob',
          timeout: 3000000 // 50 minutos para descargas grandes
        });

        // Crear un enlace de descarga
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Obtener el nombre del archivo del header Content-Disposition o usar un nombre por defecto
        const contentDisposition = response.headers['content-disposition'];
        let filename = `documentos_${esquema.value.nombre || 'exportacion'}_${new Date().toISOString().split('T')[0]}.zip`;
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
          }
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        showNotification('Descarga de ZIP iniciada correctamente', 'alert-success');
      } catch (error) {
        console.error('Error al descargar ZIP:', error);

        // Manejo de errores específicos según el código de respuesta
        let errorMessage = 'Error al descargar el ZIP con los documentos';

        if (error.response?.status === 400) {
          errorMessage = 'Parámetros de filtrado inválidos';
        } else if (error.response?.status === 403) {
          errorMessage = 'Sin permisos para descargar estos documentos';
        } else if (error.response?.status === 404) {
          errorMessage = 'Esquema no encontrado';
        } else if (error.response?.status === 500) {
          errorMessage = 'Error en la generación del archivo ZIP';
        }

        showNotification(errorMessage, 'alert-danger');
      } finally {
        descargandoZip.value = false;
      }
    };

    // Función para obtener los datos del backend
    const fetchEsquema = async () => {
      cargando.value = true; // Activar el spinner
      try {
        const response = await axiosInstance.get("/api/datosesquema/" + id.value);
        esquema.value = response.data.esquema;
        if (esquema.value.visualizable === false) {
          console.log("Esquema no es visualizable, redirigiendo...");
          router.push('/');
          return;
        }
        searchFilters.value = {
          ...esquema.value.propiedades.reduce((acc, columna) => {
            acc[columna.campoBD] = "";
            return acc;
          }, {})
        };

        // Inicializar filtros avanzados
        initializeFilters();

        // Aplicar filtros desde query params si existen
        applyQueryParamsFilters();

        // Ajustar anchos de columnas después de cargar el esquema
        nextTick(() => {
          adjustColumnWidths();
        });

        // Cargar listas disponibles si hay propiedades de tipo lista
        const tienePropiedadesLista = esquema.value.propiedades.some(prop => prop.tipo === 'list');
        if (tienePropiedadesLista) {
          try {
            const listasResponse = await axiosInstance.get("/api/listas");
            listasDisponibles.value = listasResponse.data.data || [];
          } catch (error) {
            listasDisponibles.value = [];
          }
        }
      } catch (error) {
        showNotification("Error al obtener los datos", 'alert-danger');
      } finally {
        cargando.value = false; // Desactivar el spinner
      }
    };

    // Función para obtener los datos del backend
    const fetchData = async () => {
      cargando.value = true; // Activar el spinner
      try {
        const params = {
          columns: esquema.value.propiedades.map(columna => {
            const operator = filterOperators[columna.campoBD]?.operator || '=';
            return {
              search: {
                value: searchFilters.value[columna.campoBD] || '',
                operator: operator,
                filterValue: filterValues[columna.campoBD] || ''
              }
            };
          }),
          start: (currentPage.value - 1) * pageLength.value,
          length: pageLength.value,
          draw: Date.now(),
          // Parámetros de ordenamiento
          sort_column: sortColumn.value,
          sort_direction: sortDirection.value,
          // Filtro de estado (pendientes/rechazados)
          estado: estadoFiltro.value || undefined
        };

        const response = await axiosInstance.get("/api/registrosesquema/" + id.value, { params });
        data.value = response.data.data;
        filteredData.value = data.value;
        totalRecords.value = response.data.recordsTotal;
        recordsFiltered.value = response.data.recordsFiltered;
        // Actualizar el estado de selección después de cargar datos
        updateSelectAllState();
        // Ajustar anchos de columnas después de cargar los datos
        adjustColumnWidths();
      } catch (error) {
        console.error("Error fetching data", error);
        showNotification("Error al obtener los datos", 'alert-danger');
      } finally {
        cargando.value = false; // Desactivar el spinner
      }
    };

    // Funciones para filtrar por estado de aprobación
    const verPendientes = () => {
      estadoFiltro.value = 'pendientes';
      currentPage.value = 1;
      fetchData();
    };

    const verRechazados = () => {
      estadoFiltro.value = 'rechazados';
      currentPage.value = 1;
      fetchData();
    };

    const verTodos = () => {
      estadoFiltro.value = null;
      currentPage.value = 1;
      fetchData();
    };

    // Función para cambiar el ordenamiento
    const cambiarOrdenamiento = (columna) => {
      if (sortColumn.value === columna) {
        // Si es la misma columna, cambiar la dirección
        sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
      } else {
        // Si es una nueva columna, establecer como ascendente
        sortColumn.value = columna;
        sortDirection.value = 'asc';
      }
      // Volver a la primera página cuando se cambia el ordenamiento
      currentPage.value = 1;
      fetchData();
    };

    // Función para obtener el icono de ordenamiento
    const getSortIcon = (columna) => {
      if (sortColumn.value !== columna) {
        return 'fa-sort'; // Sin ordenar
      }
      return sortDirection.value === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
    };

    // Cuando cambian los filtros, actualizar la tabla
    //watch(searchFilters, fetchData, {deep: true});
    watch(pageLength, fetchData);

    // Función para ajustar los anchos de las columnas dinámicamente
    const adjustColumnWidths = () => {
      nextTick(() => {
        const table = document.getElementById('dynamicTable');
        if (!table) return;

        const checkboxColumn = 50; // Ancho fijo de la columna del checkbox
        const minWidth = 140;
        const maxWidth = 300;
        
        // Obtener todas las columnas excepto la primera (checkbox)
        const columns = Array.from(table.querySelectorAll('th:not(:first-child)'));
        if (columns.length === 0) return;

        // Calcular anchos basados en el contenido
        const columnWidths = columns.map((th, index) => {
          const cell = th;
          // Usar scrollWidth para obtener el ancho real del contenido
          const contentWidth = cell.scrollWidth;
          // Calcular el ancho necesario, respetando min/max
          let width = Math.max(minWidth, Math.min(contentWidth, maxWidth));
          
          // Si el contenido es más ancho que el máximo, usar el ancho del contenido
          // pero limitado al máximo solo si es necesario
          if (contentWidth > maxWidth) {
            width = maxWidth;
          }
          
          return { element: th, index, width, contentWidth };
        });

        // Calcular el ancho total necesario
        const totalNeededWidth = columnWidths.reduce((sum, col) => sum + col.width, 0);
        const tableWidth = table.offsetWidth;
        const availableWidth = tableWidth - checkboxColumn;

        // Si hay espacio extra disponible, distribuirlo proporcionalmente
        if (totalNeededWidth < availableWidth) {
          const extraSpace = availableWidth - totalNeededWidth;
          const totalContentWidth = columnWidths.reduce((sum, col) => sum + col.contentWidth, 0);
          
          // Distribuir el espacio extra proporcionalmente al contenido
          columnWidths.forEach(col => {
            if (totalContentWidth > 0) {
              const proportion = col.contentWidth / totalContentWidth;
              const additionalWidth = extraSpace * proportion;
              col.width = Math.min(maxWidth, col.width + additionalWidth);
            }
          });
        }
        // Si necesitamos más espacio, NO reducir - permitir que la tabla se expanda
        // El scroll horizontal aparecerá automáticamente gracias a table-responsive

        // Aplicar los anchos calculados
        columnWidths.forEach(({ element, width }) => {
          element.style.width = `${width}px`;
          element.style.minWidth = `${minWidth}px`;
          element.style.maxWidth = `${maxWidth}px`;
        });

        // Aplicar también a las celdas del cuerpo
        const bodyRows = table.querySelectorAll('tbody tr');
        bodyRows.forEach(row => {
          const cells = Array.from(row.querySelectorAll('td:not(:first-child)'));
          cells.forEach((cell, index) => {
            if (columnWidths[index]) {
              cell.style.width = `${columnWidths[index].width}px`;
              cell.style.minWidth = `${minWidth}px`;
              cell.style.maxWidth = `${maxWidth}px`;
            }
          });
        });
      });
    };

    onMounted(async () => {
      // Primero cargar el esquema (esto también aplicará los filtros de query params)
      await fetchEsquema();
      // Luego cargar los datos con los filtros ya aplicados
      fetchData();

      // Ajustar anchos de columnas cuando cambia el tamaño de la ventana
      const handleResize = () => {
        adjustColumnWidths();
      };
      window.addEventListener('resize', handleResize);
      
      // Guardar referencia para poder limpiarlo en onBeforeUnmount
      window._handleResizeTableView = handleResize;

      // Cerrar dropdowns al hacer clic fuera
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.filter-operator-wrapper')) {
          Object.keys(showOperatorDropdown).forEach(key => {
            showOperatorDropdown[key] = false;
          });
        }
      });
    });

    onBeforeUnmount(() => {
      // Limpiar event listener de dropdowns
      document.removeEventListener('click', (event) => {
        if (!event.target.closest('.filter-operator-wrapper')) {
          Object.keys(showOperatorDropdown).forEach(key => {
            showOperatorDropdown[key] = false;
          });
        }
      });
      // Limpiar event listener de resize
      if (window._handleResizeTableView) {
        window.removeEventListener('resize', window._handleResizeTableView);
        delete window._handleResizeTableView;
      }
    });

    const showNotification = (message, type) => {
      const notification = {
        message,
        class: type,
      };
      notifications.value.push(notification);

      // Cerrar la notificación automáticamente después de 2 segundos
      setTimeout(() => {
        closeNotification(notifications.value.indexOf(notification));
      }, 2000); // 2000 milisegundos = 2 segundos
    };

    // Formatear decimales a un número con precisión fija
    const formatDecimal = (value, digits) => {
      return value ? parseFloat(value).toFixed(digits) : "";
    };
    const formatDate = (value) => {
      if (value) {
        const d = new Date(value);
        return ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
      } else {
        return '';
      }
    };

    const formatDateTime = (value) => {
      if (!value) return '';
      const d = new Date(value);
      const pad = (n) => ("0" + n).slice(-2);
      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = d.getFullYear();
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      const seconds = pad(d.getSeconds());
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    // Actualizar decimales en el modelo
    const updateDecimal = (campo, event, digits) => {
      const value = parseFloat(event.target.value).toFixed(digits);
      registroSeleccionado[campo] = isNaN(value) ? null : parseFloat(value);
    };

    const syncRegistroEnListas = (registro) => {
      if (!registro || !registro.id) return;
      const actualizarEn = (coleccionRef) => {
        if (!coleccionRef.value || !Array.isArray(coleccionRef.value)) return;
        const idx = coleccionRef.value.findIndex((r) => r.id === registro.id);
        if (idx !== -1) {
          // Reemplazar el objeto completo para respetar la reactividad
          coleccionRef.value[idx] = { ...coleccionRef.value[idx], ...registro };
        }
      };
      actualizarEn(data);
      actualizarEn(filteredData);
    };

    const guardarRegistro = async () => {
      try {
        const resp = await axiosInstance.post("/api/registroesquema/" + id.value, { registro: registroSeleccionado.value });
        registroSeleccionado.value = resp.data.registro;
        syncRegistroEnListas(resp.data.registro);
        showNotification('Documento guardado.', 'alert-success');
      } catch (error) {
        console.error("Error fetching data", error);
        showNotification("Error al obtener los datos", 'alert-danger');
      }
    };

    // Función para cerrar el modal
    const cerrarModalNuevoRegistro = () => {
      // Cerrar el modal usando la API de Bootstrap
      const modalElement = document.getElementById('modalNuevoRegistro');
      if (modalElement) {
        // Intentar usar Bootstrap 5
        const Bootstrap = window.bootstrap || window.Bootstrap;
        if (Bootstrap && Bootstrap.Modal) {
          const modal = Bootstrap.Modal.getInstance(modalElement);
          if (modal) {
            modal.hide();
          } else {
            // Si no existe la instancia, crear una nueva y cerrarla
            const newModal = new Bootstrap.Modal(modalElement);
            newModal.hide();
          }
        } else {
          // Fallback: usar jQuery si está disponible (Bootstrap 4)
          if (window.$ && window.$.fn.modal) {
            window.$('#modalNuevoRegistro').modal('hide');
          } else {
            // Último recurso: ocultar manualmente
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            document.body.classList.remove('modal-open');
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.remove();
            }
          }
        }
      }
    };


    // Referencia al modal de nuevo registro
    const modalNuevoRegistroRef = ref(null);

    // Función para crear un nuevo registro
    const crearRegistro = async (data) => {
      try {
        await axiosInstance.post("/api/registroesquema/" + id.value, {
          registro: data.registro,
          archivo: data.archivo
        });
        showNotification('Registro creado exitosamente', 'alert-success');
        // Marcar el modal para que se limpie cuando se cierre
        const modalElement = document.getElementById('modalNuevoRegistro');
        if (modalElement) {
          modalElement.setAttribute('data-clean-on-close', 'true');
        }
        // Intentar limpiar directamente antes de cerrar
        await nextTick();
        try {
          if (modalNuevoRegistroRef.value && typeof modalNuevoRegistroRef.value.limpiarFormulario === 'function') {
            modalNuevoRegistroRef.value.limpiarFormulario();
          }
        } catch (e) {
          console.warn('No se pudo limpiar el formulario directamente:', e);
        }
        // Cerrar el modal - esto disparará el evento hidden.bs.modal que también limpiará
        cerrarModalNuevoRegistro();
        // Refrescar la tabla después de crear el registro
        await fetchData();
      } catch (error) {
        // Manejar errores de axios correctamente
        const mensaje = error.response?.data?.message || 
                       error.response?.data?.error || 
                       error.message || 
                       'Error al crear el registro';
        showNotification(mensaje, 'alert-danger');
      }
    };




    // Variables para listas
    const listasDisponibles = ref([]);
    // Cache para valores de listas (listaId -> valores[])
    const valoresListasCache = ref({});
    const valoresListasPending = ref({});










    // Función para cargar valores de una lista (una sola petición por lista_id)
    const cargarValoresLista = async (listaId) => {
      if (!listaId || valoresListasCache.value[listaId]) return;
      if (valoresListasPending.value[listaId]) return valoresListasPending.value[listaId];

      const promise = (async () => {
        try {
          const response = await axiosInstance.get(`/api/listas/${listaId}/valores`);
          const valores = response.data.data?.lista?.valores ?? response.data.lista?.valores ?? [];
          valoresListasCache.value[listaId] = valores;
          return valores;
        } catch (error) {
          console.error(`Error al obtener valores de la lista ${listaId}:`, error);
          valoresListasCache.value[listaId] = [];
          return [];
        } finally {
          delete valoresListasPending.value[listaId];
        }
      })();
      valoresListasPending.value[listaId] = promise;
      return promise;
    };

    // Función para obtener valores de una lista (síncrona, usa cache)
    const obtenerValoresLista = (listaId) => {
      if (!listaId) return [];
      
      // Si no están en cache, iniciar carga asíncrona
      if (!valoresListasCache.value[listaId]) {
        cargarValoresLista(listaId);
        return []; // Retornar vacío mientras carga
      }
      
      return valoresListasCache.value[listaId] || [];
    };

    // Función para obtener la descripción de un valor de lista
    const obtenerDescripcionValorLista = async (listaId, valorId) => {
      if (!listaId || !valorId) return '';
      
      // Asegurar que los valores estén cargados
      if (!valoresListasCache.value[listaId]) {
        await cargarValoresLista(listaId);
      }
      
      const valores = valoresListasCache.value[listaId] || [];
      const valor = valores.find(v => v.id === valorId);
      return valor ? valor.descripcion : '';
    };

    // Función para formatear el nombre de la propiedad (reemplazar _ por espacios)
    const formatearNombrePropiedad = (nombre) => {
      if (!nombre) return '';
      return nombre.replace(/_/g, ' ');
    };

    // Función para obtener el icono del archivo según su extensión
    const getFileIcon = (item) => {
      // Intentar obtener la extensión del item
      let extension = '';

      // Primero intentar obtener la extensión directamente
      if (item.extension) {
        extension = item.extension.toLowerCase().replace('.', '');
      } else {
        // Si no hay extensión directa, intentar extraerla de algún campo de nombre de archivo
        // Buscar en todas las propiedades del esquema por un campo que contenga el nombre del archivo
        if (esquema.value?.propiedades) {
          for (const propiedad of esquema.value.propiedades) {
            const valor = item[propiedad.campoBD];
            if (valor && typeof valor === 'string' && valor.includes('.')) {
              const partes = valor.split('.');
              if (partes.length > 1) {
                extension = partes[partes.length - 1].toLowerCase();
                break;
              }
            }
          }
        }
      }

      // Mapeo de extensiones a iconos
      const iconMap = {
        'pdf': '/img/files/fi-pdf.svg',
        'jpg': '/img/files/fi-jpg.svg',
        'jpeg': '/img/files/fi-jpg.svg',
        'png': '/img/files/fi-jpg.svg',
        'gif': '/img/files/fi-jpg.svg',
        'bmp': '/img/files/fi-jpg.svg',
        'webp': '/img/files/fi-jpg.svg',
        'txt': '/img/files/fi-txt.svg',
        'csv': '/img/files/fi-csv.svg',
        'xlsx': '/img/files/fi-xlsx.svg',
        'xls': '/img/files/fi-xls.svg',
        'docx': '/img/files/fi-docx.svg',
        'doc': '/img/files/fi-doc.svg',
        'zip': '/img/files/fi-zip.svg',
        'json': '/img/files/fi-json.svg'
      };

      // Retornar el icono correspondiente o el icono por defecto
      return iconMap[extension] || '/img/files/any-file.png';
    };

    // Función para obtener el texto alternativo del icono
    const getFileIconAlt = (item) => {
      let extension = '';
      if (item.extension) {
        extension = item.extension.toLowerCase().replace('.', '');
      }
      return extension ? `Archivo ${extension.toUpperCase()}` : 'Archivo';
    };




    const confirmarEliminar = async (registro) => {
      try {
        await axiosInstance.post(`/api/borrarregistro/${id.value}`, { registro: registro });
        showNotification('Registro eliminado.', 'alert-success');
        await fetchData();
        registroSeleccionado.value = null;
      } catch (error) {
        showNotification('Error al eliminar el registro.', 'alert-danger');
      }
    };

    const clonarRegistro = (obj) => {
      if (!obj) return obj;
      try {
        // Preferir structuredClone si existe
        if (typeof structuredClone === 'function') return structuredClone(obj);
      } catch (e) {
        // Fallback a JSON más abajo (structuredClone puede fallar con proxies/refs)
      }
      // Fallback
      return JSON.parse(JSON.stringify(obj));
    };

    const actualizarRegistro = async (registro) => {
      // Importante: NO sincronizar con la tabla mientras se edita (solo al Guardar)
      if (registro && registro.id) {
        if (!registroSeleccionado.value || typeof registroSeleccionado.value !== 'object') {
          registroSeleccionado.value = registro;
        } else {
          Object.assign(registroSeleccionado.value, registro);
        }
      }
    };



    const seleccionarRegistro = (item) => {
      // Clonar para que la edición NO modifique la fila de la tabla en vivo
      registroSeleccionado.value = clonarRegistro(item);
    };



    return {
      esquema,
      notifications,
      closeNotification,
      showNotification,
      registroSeleccionado,
      fetchData,
      data,
      filteredData,
      searchFilters,
      pageLength,
      currentPage,
      totalRecords,
      recordsFiltered,
      formatDecimal,
      formatDate,
      formatDateTime,
      updateDecimal,
      totalPages,
      paginationRange,
      registrosMostrados,
      changePage,
      changePageSize,
      selectedRows,
      selectAll,
      toggleRowSelection,
      toggleSelectAll,
      clearSelection,
      isRowSelected,
      descargarSeleccionados,
      descargando,
      exportarAExcel,
      exportando,
      descargarZipFiltrado,
      descargandoZip,
      mostrarModalConfirmarZip,
      confirmarDescargarZip,
      cargando,
      guardarRegistro,
      cerrarModalNuevoRegistro,
      crearRegistro,
      modalNuevoRegistroRef,
      confirmarEliminar,
      actualizarRegistro,
      seleccionarRegistro,
      // Variables para listas
      id,
      listasDisponibles,
      obtenerValoresLista,
      obtenerDescripcionValorLista,
      // Funciones de formateo
      formatearNombrePropiedad,
      getFileIcon,
      getFileIconAlt,
      // Computed properties
      propiedadesAgrupadas,
      // Variables de ordenamiento
      sortColumn,
      sortDirection,
      // Funciones de ordenamiento
      cambiarOrdenamiento,
      getSortIcon,
      // Variables y funciones de filtro por estado
      estadoFiltro,
      verPendientes,
      verRechazados,
      verTodos,
      // Variables de filtros avanzados
      filterOperators,
      filterValues,
      showOperatorDropdown,
      filters_operator,
      // Funciones de filtros
      getAvailableOperators,
      getDefaultOperator,
      initializeFilters,
      limpiarFiltros,
      getOperatorDisplay,
      toggleOperatorDropdown,
      selectOperator,
      getCellValue,
    };
  },
}
</script>

<style scoped>
.pdf-container {
  height: 70vh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
}

.pdf-container-completa {
  height: 100dvh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
}

.image-container img {
  max-width: 100%;
  height: auto;
}

.file-container {
  margin-top: 16px;
}

/* Estilos para el icono de archivo que actúa como checkbox */
.file-icon-checkbox {
  display: inline-block;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.file-icon-checkbox:hover {
  opacity: 1 !important;
  transform: scale(1.1);
}

.file-icon-selected {
  filter: drop-shadow(0 0 3px rgba(13, 110, 253, 0.5));
}

/* Estilos para la fila seleccionada (cuando se abre el visor) */
.row-selected {
  background-color: #e7f3ff !important;
  border-left: 4px solid #0d6efd !important;
}

.row-selected:hover {
  background-color: #d0e7ff !important;
}

.row-selected td {
  background-color: transparent !important;
}

/* Estilos para filas de documentos caducados */
.row-caducado {
  background-color: #f8d7da !important;
}

.row-caducado:hover {
  background-color: #f1aeb5 !important;
}

.row-caducado td {
  background-color: transparent !important;
}

/* Estilos para el footer de la tabla */
.table-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  margin-top: 0;
}

.footer-selection-info {
  font-size: 0.875rem;
  color: #6c757d;
}

.footer-pagination-controls {
  font-size: 0.875rem;
  align-items: center;
  height: 100%;
}

.footer-pagination-controls>* {
  display: flex;
  align-items: center;
}

.footer-select {
  border-radius: 0.375rem;
  border: 1px solid #ced4da;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.footer-nav-btn {
  border-radius: 0.375rem;
  padding: 0.25rem 0.5rem;
  min-width: 32px;
  height: 32px;
  border: 1px solid #ced4da;
  background-color: #fff;
  color: #212529;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin-bottom: 0;
}

.footer-nav-btn:hover:not(:disabled) {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.footer-nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-tabs-nowrap {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  white-space: nowrap;
}

.nav-tabs-nowrap .nav-item {
  float: none;
  display: inline-block;
}

/* Evitar scroll vertical en las pestañas */
.nav-tabs {
  overflow-y: visible !important;
}

/* Scroll vertical solo en el contenido de la pestaña 'Contenido' */
.ocr-content-scroll {
  max-height: 70vh;
  overflow-y: auto;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 1rem;
}

.celda-ellipsis {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Subpestañas que "abren" hacia arriba */
.subtabs-bottom {
  border-top: 1px solid #dee2e6;
  border-bottom: none;
}

.subtabs-bottom .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
  border-bottom: none;
  color: #5e72e4;
}

.subtabs-bottom .nav-link:hover {
  border-color: transparent;
}

.subtabs-bottom .nav-link.active {
  color: #344767;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 transparent;
  border-bottom: 1px solid #fff;
  /* se funde con el panel superior */
}

/* Forzar que el header y el dropdown se muestren sobre el body y ocultar scroll del header */
.card-header {
  position: relative;
  z-index: auto;
  overflow: visible !important;
}

.card-body {
  position: relative;
  z-index: 1;
}

.nav-tabs {
  overflow: visible !important;
}

.dropdown-menu {
  position: absolute;
  z-index: 1055;
  /* por encima del body */
}

/* Estilos para el accordion de propiedades */
.accordion-item {
  border: 1px solid #dee2e6;
  margin-bottom: 8px;
  border-radius: 0.375rem;
  overflow: hidden;
}

.accordion-item:last-child {
  margin-bottom: 0;
}

.accordion-button {
  background-color: #f8f9fa;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  color: #495057;
  padding: 1rem 1.25rem;
}

.accordion-button:not(.collapsed) {
  background-color: #e9ecef;
  color: #212529;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion-button:focus {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  border-color: #86b7fe;
}

.accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  transition: transform 0.2s ease-in-out;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
}

.accordion-button:not(.collapsed)::after {
  transform: rotate(180deg);
}

.accordion-body {
  padding: 1.25rem;
  background-color: #fff;
}

.accordion-collapse {
  border-top: 1px solid #dee2e6;
}

/* Estilos para headers ordenables */
.sortable-header {
  transition: color 0.2s ease;
}

.sortable-header:hover {
  color: #0d6efd !important;
}

.sortable-header i {
  font-size: 0.8em;
  opacity: 0.7;
}

.sortable-header:hover i {
  opacity: 1;
}

/* Estilos para filtros avanzados */
.filter-container {
  min-height: 40px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 140px;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: visible;
}

.filter-input-group {
  display: flex;
  gap: 0;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.filter-value-with-selector {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: none;
  box-sizing: border-box;
}

.filter-operator-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  z-index: 10;
}

.filter-operator-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
  border: 1px solid #dee2e6;
  border-radius: 0 0.25rem 0.25rem 0;
  background-color: #f8f9fa;
  min-width: 40px;
  cursor: pointer;
  user-select: none;
}

.filter-operator-dropdown:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.filter-operator-display {
  font-weight: 500;
  color: #495057;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-operator-arrow {
  font-size: 0.6rem;
  color: #6c757d;
  margin-left: 0.25rem;
  transition: transform 0.2s ease;
}

.filter-operator-dropdown.show .filter-operator-arrow {
  transform: rotate(180deg);
}

.filter-operator-menu {
  position: fixed;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 1055;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
}

.filter-operator-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  font-size: 0.8rem;
  border-bottom: 1px solid #f8f9fa;
}

.filter-operator-option:hover {
  background-color: #f8f9fa;
}

.filter-operator-option.active {
  background-color: #e3f2fd;
  color: #1976d2;
}

.filter-operator-option:last-child {
  border-bottom: none;
}

.operator-label {
  font-weight: 500;
}

.operator-symbol {
  font-weight: 600;
  color: #6c757d;
  margin-left: 0.5rem;
}

/* Estilos para la tabla dinámica */
.col-lg-8 .card-body {
  overflow-x: hidden;
  overflow-y: visible;
  width: 100%;
  max-width: 100%;
}

/* Asegurar que el thead y los filtros se muestren por encima */
#dynamicTable thead {
  position: relative;
  z-index: 5;
}

#dynamicTable thead th {
  position: relative;
  overflow: visible;
}

.col-lg-8 .table-responsive {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible !important;
  max-width: 100%;
  box-sizing: border-box;
  display: block;
  position: relative;
}

.col-lg-8 .table-responsive > table {
  width: 100%;
  max-width: 100%;
}

#dynamicTable {
  table-layout: fixed;
  width: auto;
  min-width: 100%;
  box-sizing: border-box;
  margin: 0;
}

/* Columna del checkbox - siempre 50px */
#dynamicTable th:first-child,
#dynamicTable td:first-child {
  width: 50px !important;
  min-width: 50px !important;
  max-width: 50px !important;
  box-sizing: border-box;
}

/* Demás columnas */
#dynamicTable th:not(:first-child) {
  min-width: 140px !important;
  max-width: 300px !important;
  width: auto !important;
  box-sizing: border-box;
}

#dynamicTable td:not(:first-child) {
  min-width: 140px !important;
  max-width: 300px !important;
  box-sizing: border-box;
}

/* Estilos para celdas truncadas */
.table-cell-truncated {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-cell-truncated:hover {
  background-color: #f8f9fa;
}

.filter-value {
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

.filter-range {
  display: flex;
  gap: 2px;
}

.filter-range input {
  flex: 1;
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
}

.filter-empty {
  font-size: 0.7rem;
  color: #6c757d;
  text-align: center;
  padding: 0.2rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
}
</style>
